import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SegmentedTabs from 'shared/components/ui/SegmentedTabs';
import Icon from 'shared/components/Icon';
import { useBreadcrumbActions } from 'shared/context/BreadcrumbContext';

/**
 * Grain switcher for the Traces page, rendered into the GlobalTopBar's actions
 * slot next to the breadcrumb path (same as the Activity switcher).
 *
 * Conversations → Runs → Spans is a strict containment hierarchy: a
 * conversation is a sequence of runs, a run is a tree of spans. Ordering the
 * tabs coarse-to-fine makes the strip read as a zoom control rather than three
 * unrelated pages. Runs is the default — it's the unit of value; conversations
 * are for support-style debugging and spans for deep debugging.
 */
const VIEWS = [
  {
    value: 'conversations',
    label: 'Conversations',
    hint: 'Runs grouped into one exchange with a user',
    icon: ({ size }) => <Icon name="conversation" size={size} color="currentColor" />,
  },
  {
    value: 'runs',
    label: 'Runs',
    hint: 'One agent execution per row',
    icon: ({ size }) => <Icon name="timeline" size={size} color="currentColor" />,
  },
  {
    value: 'spans',
    label: 'Spans',
    hint: 'Individual steps inside runs',
    icon: ({ size }) => <Icon name="span" size={size} color="currentColor" />,
  },
];

/** Tab value → route subpath. `spans` still lives at /traces for old links. */
const ROUTE_FOR = {
  conversations: 'conversations',
  runs: 'runs',
  spans: 'traces',
};

const TracesViewTabs = ({ value }) => {
  const navigate = useNavigate();
  const params = useParams();
  const team = params.team || localStorage.getItem('selectedTeam') || '';

  useBreadcrumbActions(
    <SegmentedTabs
      options={VIEWS}
      value={value}
      size="sm"
      ariaLabel="Traces view"
      onChange={(next) =>
        navigate(`/${encodeURIComponent(team)}/agent-analytics/${ROUTE_FOR[next] || next}`)
      }
    />
  );

  return null;
};

export default TracesViewTabs;
